export default __webpack_public_path__ + "static/media/HandLetteredMenu400.43d70e76.jpg";